export default __webpack_public_path__ + "static/media/explore-tablet-4.3fcd80ff.png";